<template>
  <span>
    <b-form-group :label="label" label-class="v3_color_teal v2_font_size_18 v2_font_weight_semibold font-weight-bold">
      <b-row>
        <b-col>
          <b-form-group
            :label="hasBoardCertificationLabel"
            label-cols="12"
            label-align-md="5"
            label-class="v3_color_teal"
          >
            <b-form-radio-group
              :checked="hasBoardCertification"
              @input="showTooltipModal($event)"
              class="v2_control_radio_group_small"
            >
              <b-form-radio :value="1">Yes</b-form-radio>
              <b-form-radio :value="0">No</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="hasBoardCertification">
        <b-col xs="12" md="8" class="pr-3 pr-md-1">
          <div class="bc-list w-100 border_1 border_black_knight rounded_2">
            <user-profile-board-certification-item
              v-for="c in sortedCertifications"
              :certification="c"
              :key="c.id"
              @itemSelected="onSelectedItem"
            />
          </div>
          <div class="d-flex align-items-center justify-content-start mt-3">
            <b-button
              :disabled="disabled"
              variant="v3_teal_outline"
              :class="{'bkg-color': hasBoardCertification}"
              @click="openModal"
            >
              Add
            </b-button>
            <b-button
              :disabled="disabled"
              variant="v3_teal_outline"
              class="ml-4"
              @click="onRemove"
            >
              Remove
            </b-button>
          </div>
        </b-col>
        <b-col xs="12" md="4" class="font_size_750rem pl-4">
          <div class="text-uppercase letter_spacing_20">Key</div>
          <div class="mt-2 d-flex align-items-center">
            <b-badge variant="v3_teal" class="mr-1 rounded_0">
              &nbsp;&nbsp;
            </b-badge>
            = Certified
          </div>
          <div class="mt-2 d-flex align-items-center">
            <b-badge variant="v3_lime" class="eligible mr-1 rounded_0">
              &nbsp;&nbsp;
            </b-badge>
            = Eligible
          </div>
        </b-col>
      </b-row>
    </b-form-group>

      <b-modal
      size="md"
      centered
      hide-footer
      header-class="job-profile-summary-header justify-content-start"
      body-class="v2_font_size_18"
      :visible="showBoardCerificationActiveModal"
      @hidden="!showBoardCerificationActiveModal"
    >
      <p>Click "Add" to select the applicable Board(s) and whether you are certified or eligible.</p>
      <template #modal-footer>
        <b-button
            variant="v2_primary"
            class="mb-3 mr-3"
            @click="closeBoardCerificationActiveModal"
        >
            Close
        </b-button>
      </template>
    </b-modal>

    <user-profile-board-certification-modal
      :key="modalOpensCounter"
      :visible="showModal"
      :boards="certifyingBoards"
      :certifications="boardCertifications"
      :excluded-certification-ids="excludedCertificationIds"
      @modalClose="showModal = false"
      @addItem="onAddItem"
    />
  </span>
</template>

<script>
import { GET_CERTIFYING_BOARDS_ACTION } from '@/store/certifyingBoards';
import { GET_BOARD_CERTIFICATIONS_ACTION } from '@/store/boardCertications';
import UserProfileBoardCertificationItem from '@/components/users/profile/BoardCertification/UserProfileBoardCertificationItem';
import UserProfileBoardCertificationModal from '@/components/users/profile/BoardCertification/UserProfileBoardCertificationModal';
import OpensCounterMixin from '@/mixins/OpensCounterMixin';
import GetBoardCertificationsMixin from '@/mixins/GetBoardCertificationsMixin';
import { alphanumericallyKeyComparator } from '@/helpers/BoardCertificationHelper';
import { GET_SOCIETY_CERTIFYING_BOARDS_ACTION } from '@/store/societyCertifyingBoards';

export default {
  name: 'UserProfileBoardsCertificationList',
  mixins: [OpensCounterMixin, GetBoardCertificationsMixin],
  components: {
    UserProfileBoardCertificationItem,
    UserProfileBoardCertificationModal,
  },
  props: {
    certifications: {
      type: Array,
      default: () => [],
    },
    excludedCertificationIds: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Board Certifications:',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasBoardCertification: {
      type: Number,
      default: 0,
    },
    hasBoardCertificationLabel: {
      type: String,
      required: true,
    },
    societyId: {
      validator: (prop) => typeof prop === 'number' || prop === null,
    },
  },
  data: function () {
    return {
      selectedItems: [],
      showModal: false,
      showBoardCerificationActiveModal:false,
    };
  },
  computed: {
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
    sortedCertifications: function () {
      return [...this.certifications].sort(alphanumericallyKeyComparator);
    },
    certifyingBoards: function () {
      return this.societyCertifyingBoardIds.length
        ? this.$store.state.certifyingBoards.items.filter((i) =>
            this.societyCertifyingBoardIds.includes(parseInt(i.id))
          )
        : this.$store.state.certifyingBoards.items;
    },
    boardCertifications: function () {
      return this.$store.state.boardCertifications.items;
    },
    societyCertifyingBoards: function () {
      return (
        this.societyId &&
        Array.isArray(this.$store.state.societyCertifyingBoards.items) &&
        this.$store.state.societyCertifyingBoards.items.filter(
          (i) => parseInt(i.society_id) === this.societyId
        )
      );
    },
    societyCertifyingBoardIds: function () {
      return Array.isArray(this.societyCertifyingBoards)
        ? this.societyCertifyingBoards.map((b) =>
            parseInt(b.certifying_board_id)
          )
        : [];
    },
  },
  methods: {
    uploadData: async function () {
      try {
        this.$wait.start(this.loaderId);
        await Promise.all([
          this.$store.dispatch(GET_SOCIETY_CERTIFYING_BOARDS_ACTION),
          this.$store.dispatch(GET_CERTIFYING_BOARDS_ACTION),
          this.$store.dispatch(GET_BOARD_CERTIFICATIONS_ACTION),
        ]);
      } catch (error) {
        process.env.NODE_ENV !== 'production' && console.error(error);
        this.$toasted.show('Some error occurs', {
          type: 'error',
          duration: 3000,
        });
      } finally {
        this.$wait.end(this.loaderId);
      }
    },
    onSelectedItem: function ({ id, isSelected }) {
      if (isSelected) {
        this.selectedItems.push(parseInt(id));
      } else {
        const index = this.selectedItems.findIndex((el) => el === parseInt(id));
        this.selectedItems.splice(index, 1);
      }
    },
    onAddItem: function ({ id, is_certified }) {
      const certification = this.boardCertifications.find((bc) => bc.id === id);
      this.$emit('addBoardCertification', {
        ...certification,
        is_certified,
      });
    },
    onRemove: function () {
      this.selectedItems.forEach((id) => {
        const index = this.certifications.findIndex(
          (bc) => parseInt(bc.id) === id
        );
        this.certifications.splice(index, 1);
      });
      this.selectedItems = [];
    },
    openModal: function () {
      this.onModalShow();
      this.showModal = true;
    },
    showTooltipModal: function (event) {
      if(event==true){
        this.showBoardCerificationActiveModal = true;
      }
      this.$emit('update-has-board-certification', event);
    },
    closeBoardCerificationActiveModal: function () {
      this.showBoardCerificationActiveModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../sass/variables_mixins.scss';
.bc-list {
  height: 120px;
  max-height: 120px;
  overflow-y: auto;
}
.badge-lime {
  background-color: rgba($phairify_v2_color_secondary_lime, 0.25);
}
.badge-yellow {
  background-color: $phairify_v2_color_yellow;
}
</style>
